import {
  CollectionConstraintType,
  CompanyInfo,
  ContractFormData,
} from '../../types/contracts';
import { SkillLevel } from '../../types/driver';
import { WasteItem } from '../../types/others';
import { formatDateHypen } from '../../services/formatDate';
import { getUserResponse } from '../../types/user';

export const generateCompanyInfo = (): CompanyInfo => {
  return {
    companyId: null,
    companyPicName: '',
    phoneNumber: '',
  };
};
export const generateFormData = ({
  wasteItems,
  constraintTypes,
  skillLevels,
  currentUser,
}: {
  wasteItems: WasteItem[] | undefined;
  constraintTypes: CollectionConstraintType[] | undefined;
  skillLevels: SkillLevel[] | undefined;
  currentUser: getUserResponse | undefined;
}): ContractFormData => ({
  contractNo: '',
  receivedAt: formatDateHypen(new Date()),
  salesPic: null,
  updatedBy: currentUser?.userName ?? '',
  contractDocumentTypeId: 1,
  supplierCompanyInfo: generateCompanyInfo(),
  contractorCompanyInfo: null,
  wastePointCompanyInfo: generateCompanyInfo(),
  wastePointCompanyIsTheSameSupplier: false,
  carCategoryIds: [],
  collectionConstraintTypeId:
    constraintTypes?.[0]?.collectionConstraintTypeId ?? null,
  collectionConstraintWeekDays: [],
  collectionConstraintDateStart: '',
  collectionConstraintDateEnd: '',
  collectionConstraintTimeStart: '',
  collectionConstraintTimeEnd: '',
  collectionEstimatedTime: null,
  goesStraight: true,
  requiredSkillLevelId: skillLevels?.[0]?.skillLevelId ?? null,
  requiredQualificationIds: [],
  memo: '',
  wasteItemsInfo: [
    {
      wasteItemId: wasteItems?.[0]?.wasteItemId ?? null,
      wasteItemName: '',
      amountOfWaste: null,
      disposalSiteCompanyId: null,
      specificTimeStartAt: '',
      specificTimeEndAt: '',
    },
  ],
});
